window.TT_REVIEWS = [
  // {
  //   "product_handle": "small-cross-necklace-gold",
  //   "rating": 5,
  //   "author": "勇太 神尾",
  //   "content": "９月に初めて購入購入しました。\nネットで見たより、実物が思っていた以上に好みのデザインだったので、同じ物をプレゼント用に新たに購入しました！\nシンプルなデザインなので、重ね付け用に他のデザインも試してみたいです。",
  //   "commented_at": "2025-10-14",
  //   "reply": null,
  //   "reply_at": null,
  //   "verify_purchase": "yes",
  //   "item_type": "50cm",
  //   "photo_url_1": null,
  //   "photo_url_2": null,
  //   "photo_url_3": null,
  //   "photo_url_4": null,
  //   "photo_url_5": null,
  //   "video_url": null,
  //   "block_no": 21
  // },
  // {
  //   "product_handle": "vintage-cross-necklace-silver",
  //   "rating": 5,
  //   "author": "歩叶 野村",
  //   "content": "彼氏といろちで買いました✌️\nずっと付けてても錆びないしちぎれません！\nめっちゃいい感じです😭💗",
  //   "commented_at": "2026-01-09",
  //   "reply": "この度はご購入と素敵なレビューをありがとうございます。\n彼氏さまとお揃いで選んでいただけたとのこと、とても嬉しく拝見しました。\nこれからもお二人の毎日にそっと寄り添う存在として、長くご愛用いただけましたら幸いです。",
  //   "reply_at": "2026-01-12",
  //   "verify_purchase": "yes",
  //   "item_type": "45cm",
  //   "photo_url_1": null,
  //   "photo_url_2": null,
  //   "photo_url_3": null,
  //   "photo_url_4": null,
  //   "photo_url_5": null,
  //   "video_url": null,
  //   "block_no": 1
  // },
  // {
  //   "product_handle": "small-cross-necklace-gold",
  //   "rating": 5,
  //   "author": "勇太 神尾",
  //   "content": "自分が着けていてとても気に入ってたので、パートナーにも同じ物をプレゼントしました。\nとても喜んでいました！",
  //   "commented_at": "2025-12-31",
  //   "reply": null,
  //   "reply_at": null,
  //   "verify_purchase": "yes",
  //   "item_type": "50cm",
  //   "photo_url_1": null,
  //   "photo_url_2": null,
  //   "photo_url_3": null,
  //   "photo_url_4": null,
  //   "photo_url_5": null,
  //   "video_url": null,
  //   "block_no": 3
  // },
  // {
  //   "product_handle": "85410159",
  //   "rating": 5,
  //   "author": "勇太 神尾",
  //   "content": "似たようなネックレスを着けていましたが、細くてすぐに切れて決まっていたから、こちらのネックレスは作りもしっかりしていてデザインもとても良い品だと思います。",
  //   "commented_at": "2025-12-31",
  //   "reply": null,
  //   "reply_at": null,
  //   "verify_purchase": "yes",
  //   "item_type": "45cm",
  //   "photo_url_1": null,
  //   "photo_url_2": null,
  //   "photo_url_3": null,
  //   "photo_url_4": null,
  //   "photo_url_5": null,
  //   "video_url": null,
  //   "block_no": 4
  // },
  // {
  //   "product_handle": "zirconia-hoop-pierce-rpi0060g",
  //   "rating": 5,
  //   "author": "北方 幹也",
  //   "content": "妻へのサプライズプレゼントに購入しました。\nすごく喜んでくれてよかったです。商品のクオリティーも良く満足しています。\n商品到着時の表紙にアクセサリーと表示があり、妻が受け取った際に気付かれたかと焦りました。",
  //   "commented_at": "2025-12-29",
  //   "reply": null,
  //   "reply_at": null,
  //   "verify_purchase": "yes",
  //   "item_type": null,
  //   "photo_url_1": null,
  //   "photo_url_2": null,
  //   "photo_url_3": null,
  //   "photo_url_4": null,
  //   "photo_url_5": null,
  //   "video_url": null,
  //   "block_no": 6
  // },
  // {
  //   "product_handle": "small-heart-pierce-rpi0052s",
  //   "rating": 5,
  //   "author": "紗英 村口",
  //   "content": "以前店舗で購入させて頂き、とても気に入っていたのですが片方無くしてしまったので同じものをネットで購入しました。\n私が金属アレルギーなので、サージカルステンレスのピアスは本当に重宝しています。シンプルだけど可愛くてどんな服装にも合うのでほんとにずっとつけてます。ありがとうございます",
  //   "commented_at": "2025-11-30",
  //   "reply": null,
  //   "reply_at": null,
  //   "verify_purchase": "yes",
  //   "item_type": null,
  //   "photo_url_1": null,
  //   "photo_url_2": null,
  //   "photo_url_3": null,
  //   "photo_url_4": null,
  //   "photo_url_5": null,
  //   "video_url": null,
  //   "block_no": 12
  // },
  // {
  //   "product_handle": "round-cutting-ring-rri0103g",
  //   "rating": 5,
  //   "author": "あかね 吉野",
  //   "content": "誕生日プレゼントで買ってもらいました！\nお気に入りです！\nつけっぱなしでも気にならないので毎日つけてます！",
  //   "commented_at": "2025-11-30",
  //   "reply": null,
  //   "reply_at": null,
  //   "verify_purchase": "yes",
  //   "item_type": "14号",
  //   "photo_url_1": null,
  //   "photo_url_2": null,
  //   "photo_url_3": null,
  //   "photo_url_4": null,
  //   "photo_url_5": null,
  //   "video_url": null,
  //   "block_no": 16
  // },
  // {
  //   "product_handle": "dot-chain-necklace-gold",
  //   "rating": 5,
  //   "author": "みさみさ",
  //   "content": "お風呂でもつけっぱなしOKな\nシンプルなネックレスを探していた\nところでグッドタイミングでした！\n\nどんなコーデにも合うし、\nシンプルだけどオシャレで気に入っています！\n\n何度かつけっぱなしでお風呂に入りましたが\n大丈夫でした、これからも愛用します(*^^*)",
  //   "commented_at": "2025-09-01",
  //   "reply": null,
  //   "reply_at": null,
  //   "verify_purchase": "yes",
  //   "item_type": null,
  //   "photo_url_1": null,
  //   "photo_url_2": null,
  //   "photo_url_3": null,
  //   "photo_url_4": null,
  //   "photo_url_5": null,
  //   "video_url": null,
  //   "block_no": 33
  // },
  // {
  //   "product_handle": "horseshoe-necklace-gold",
  //   "rating": 5,
  //   "author": "敏弘 萩原",
  //   "content": "商品は、いいです。\nただ、発送前にサイズ間違えて発注したので、変更したのに、それには、返信いただけず、発送準備完了しましたのメールに返信したら、発送したので、変更できませんの返信…幸い妻にはジャストサイズだったので不幸中の幸いでしたが…",
  //   "commented_at": "2025-06-29",
  //   "reply": "この度はcross Jewelliaをご利用いただき誠にありがとうございます。\nご注文に際し、ご希望に沿えずご不便をおかけしましたこと、心よりお詫び申し上げます。\n\n今後はより一層、スムーズで満足いただける対応ができるよう努めてまいります。",
  //   "reply_at": "2025-07-02",
  //   "verify_purchase": "yes",
  //   "item_type": null,
  //   "photo_url_1": null,
  //   "photo_url_2": null,
  //   "photo_url_3": null,
  //   "photo_url_4": null,
  //   "photo_url_5": null,
  //   "video_url": null,
  //   "block_no": 54
  // },
  // {
  //   "product_handle": "7204867965022",
  //   "rating": 5,
  //   "author": "TAKADA MINORU",
  //   "content": "いつも　ありがとう　ございます!\n博多　お店の　ときは、よく\n買いましったので、リゾナブル\nプライス、あと　錆びにくい\n今は、on line で　買いもの\nそれで、こないだ　在庫　すぐ\n返信　ありましったので、\nレベル　が　高い　です🛍️👍🤭",
  //   "commented_at": "2025-04-06",
  //   "reply": null,
  //   "reply_at": null,
  //   "verify_purchase": "yes",
  //   "item_type": null,
  //   "photo_url_1": null,
  //   "photo_url_2": null,
  //   "photo_url_3": null,
  //   "photo_url_4": null,
  //   "photo_url_5": null,
  //   "video_url": null,
  //   "block_no": 68
  // }
  {
    "product_handle": "small-cross-necklace-gold",
    "rating": 5,
    "author": "Y",
    "content": "ネットで見た以上に実物が好みだったので、同じ物をプレゼント用に再購入しました。\n シンプルなデザインなので、重ね付け用に他のデザインも試してみたいです。",
    "commented_at": "2025-10-14",
    "reply": null,
    "reply_at": null,
    "verify_purchase": "yes",
    "item_type": "50cm",
    "photo_url_1": null,
    "photo_url_2": null,
    "photo_url_3": null,
    "photo_url_4": null,
    "photo_url_5": null,
    "video_url": null,
    "block_no": 21
  },
  {
    "product_handle": "vintage-cross-necklace-silver",
    "rating": 5,
    "author": "A",
    "content": "彼氏といろちで買いました✌️\nずっと付けてても錆びないしちぎれません！\nめっちゃいい感じです😭💗",
    "commented_at": "2026-01-09",
    "reply": "この度はご購入と素敵なレビューをありがとうございます。\n彼氏さまとお揃いで選んでいただけたとのこと、とても嬉しく拝見しました。\nこれからもお二人の毎日にそっと寄り添う存在として、長くご愛用いただけましたら幸いです。",
    "reply_at": "2026-01-12",
    "verify_purchase": "yes",
    "item_type": "45cm",
    "photo_url_1": null,
    "photo_url_2": null,
    "photo_url_3": null,
    "photo_url_4": null,
    "photo_url_5": null,
    "video_url": null,
    "block_no": 1
  },
  {
    "product_handle": "85410159",
    "rating": 5,
    "author": "Y",
    "content": "似たようなネックレスを着けていましたが、細くてすぐに切れて決まっていたから、こちらのネックレスは作りもしっかりしていてデザインもとても良い品だと思います。",
    "commented_at": "2025-12-31",
    "reply": null,
    "reply_at": null,
    "verify_purchase": "yes",
    "item_type": "45cm",
    "photo_url_1": null,
    "photo_url_2": null,
    "photo_url_3": null,
    "photo_url_4": null,
    "photo_url_5": null,
    "video_url": null,
    "block_no": 4
  },
  {
    "product_handle": "zirconia-hoop-pierce-rpi0060g",
    "rating": 5,
    "author": "K",
    "content": "妻へのサプライズプレゼントに購入しました。\nすごく喜んでくれてよかったです。商品のクオリティーも良く満足しています。",
    "commented_at": "2025-12-29",
    "reply": null,
    "reply_at": null,
    "verify_purchase": "yes",
    "item_type": null,
    "photo_url_1": null,
    "photo_url_2": null,
    "photo_url_3": null,
    "photo_url_4": null,
    "photo_url_5": null,
    "video_url": null,
    "block_no": 6
  },
  {
    "product_handle": "small-heart-pierce-rpi0052s",
    "rating": 5,
    "author": "M",
    "content": "以前店舗で購入し気に入っていましたが、片方を無くしてしまい同じものをネットで購入しました。\n金属アレルギーでも安心して使えシンプルでどんな服装にも合うのでずっとつけています。",
    "commented_at": "2025-11-30",
    "reply": null,
    "reply_at": null,
    "verify_purchase": "yes",
    "item_type": null,
    "photo_url_1": null,
    "photo_url_2": null,
    "photo_url_3": null,
    "photo_url_4": null,
    "photo_url_5": null,
    "video_url": null,
    "block_no": 12
  },
  {
    "product_handle": "round-cutting-ring-rri0103g",
    "rating": 5,
    "author": "A",
    "content": "誕生日プレゼントで買ってもらいました！\nお気に入りです！\nつけっぱなしでも気にならないので毎日つけてます！",
    "commented_at": "2025-11-30",
    "reply": null,
    "reply_at": null,
    "verify_purchase": "yes",
    "item_type": "14号",
    "photo_url_1": null,
    "photo_url_2": null,
    "photo_url_3": null,
    "photo_url_4": null,
    "photo_url_5": null,
    "video_url": null,
    "block_no": 16
  },
  {
    "product_handle": "dot-chain-necklace-gold",
    "rating": 5,
    "author": "M",
    "content": "お風呂でもつけっぱなしOKなシンプルなネックレスを探していたところ、ちょうど見つけました。\nどんなコーデにも合い、おしゃれで気に入っています。これからも愛用します(^^)",
    "commented_at": "2025-09-01",
    "reply": null,
    "reply_at": null,
    "verify_purchase": "yes",
    "item_type": null,
    "photo_url_1": null,
    "photo_url_2": null,
    "photo_url_3": null,
    "photo_url_4": null,
    "photo_url_5": null,
    "video_url": null,
    "block_no": 33
  },
  {
    "product_handle": "small-cross-necklace-gold",
    "rating": 5,
    "author": "Y",
    "content": "自分が着けていてとても気に入ってたので、パートナーにも同じ物をプレゼントしました。\nとても喜んでいました！",
    "commented_at": "2025-12-31",
    "reply": null,
    "reply_at": null,
    "verify_purchase": "yes",
    "item_type": "50cm",
    "photo_url_1": null,
    "photo_url_2": null,
    "photo_url_3": null,
    "photo_url_4": null,
    "photo_url_5": null,
    "video_url": null,
    "block_no": 3
  },
  {
    "product_handle": "bicolor-heart-necklace-bicolor",
    "rating": 5,
    "author": "T",
    "content": "いつもありがとうございます！\n実店舗でよく購入していましたが、低価格で錆びにくいのが魅力です。\n今はオンライン購入ですが、在庫確認の返信も早く対応レベルが高いです🛍️👍🤭",
    "commented_at": "2025-04-06",
    "reply": null,
    "reply_at": null,
    "verify_purchase": "yes",
    "item_type": null,
    "photo_url_1": null,
    "photo_url_2": null,
    "photo_url_3": null,
    "photo_url_4": null,
    "photo_url_5": null,
    "video_url": null,
    "block_no": 68
  },
// 追加
  {
    "product_handle": "small-cross-necklace-gold",
    "rating": 5,
    "author": "Y",
    "content": "実際に手に取ると想像以上に仕上げが丁寧で、細部までしっかり作られている印象を受けました。普段使いにちょうど良いです。",
    "commented_at": "2026-01-20",
    "reply": null,
    "reply_at": null,
    "verify_purchase": "yes",
    "item_type": "50cm",
    "photo_url_1": null,
    "photo_url_2": null,
    "photo_url_3": null,
    "photo_url_4": null,
    "photo_url_5": null,
    "video_url": null,
    "block_no": 201
  },
  {
    "product_handle": "vintage-cross-necklace-silver",
    "rating": 5,
    "author": "T",
    "content": "派手すぎないデザインなので仕事中でも使いやすく、どんな服装にも自然に馴染むところがとても気に入っています。",
    "commented_at": "2026-01-18",
    "reply": null,
    "reply_at": null,
    "verify_purchase": "yes",
    "item_type": "45cm",
    "photo_url_1": null,
    "photo_url_2": null,
    "photo_url_3": null,
    "photo_url_4": null,
    "photo_url_5": null,
    "video_url": null,
    "block_no": 202
  },
  {
    "product_handle": "figaro-chain-necklace-gold",
    "rating": 4,
    "author": "F",
    "content": "チェーンの動きがきれいで、首元にさりげない存在感が出ます。主張しすぎないのが逆に使いやすいと感じました。",
    "commented_at": "2026-01-15",
    "reply": null,
    "reply_at": null,
    "verify_purchase": "yes",
    "item_type": "50cm / 4.5mm",
    "photo_url_1": null,
    "photo_url_2": null,
    "photo_url_3": null,
    "photo_url_4": null,
    "photo_url_5": null,
    "video_url": null,
    "block_no": 203
  },
  {
    "product_handle": "normal-ring-gold",
    "rating": 5,
    "author": "O",
    "content": "指に通したときのフィット感が良く、長時間つけていても違和感がないです！シンプルなので毎日使えそうです😀",
    "commented_at": "2026-01-10",
    "reply": null,
    "reply_at": null,
    "verify_purchase": "yes",
    "item_type": "11号",
    "photo_url_1": null,
    "photo_url_2": null,
    "photo_url_3": null,
    "photo_url_4": null,
    "photo_url_5": null,
    "video_url": null,
    "block_no": 204
  },
  {
    "product_handle": "flat-link-chain-necklace-gold",
    "rating": 5,
    "author": "N",
    "content": "価格からは想像できないほど見た目に高級感があり、友人からもよく褒められます。購入して正解でした。",
    "commented_at": "2026-01-07",
    "reply": null,
    "reply_at": null,
    "verify_purchase": "yes",
    "item_type": "50cm / 7mm",
    "photo_url_1": null,
    "photo_url_2": null,
    "photo_url_3": null,
    "photo_url_4": null,
    "photo_url_5": null,
    "video_url": null,
    "block_no": 205
  },
  {
    "product_handle": "small-heart-pierce-rpi0052s",
    "rating": 5,
    "author": "N",
    "content": "小ぶりなサイズ感が上品で、耳元がさりげなく華やかになりました😀オンオフどちらでも使いやすいです！",
    "commented_at": "2025-12-25",
    "reply": null,
    "reply_at": null,
    "verify_purchase": "yes",
    "item_type": null,
    "photo_url_1": null,
    "photo_url_2": null,
    "photo_url_3": null,
    "photo_url_4": null,
    "photo_url_5": null,
    "video_url": null,
    "block_no": 206
  },
  {
    "product_handle": "round-snake-chain-bracelet-silver",
    "rating": 4,
    "author": "M",
    "content": "手首に自然に沿うデザインで見た目がとてもきれいです！サイズ展開が増えたらさらに嬉しいと思いました☺️",
    "commented_at": "2025-12-18",
    "reply": null,
    "reply_at": null,
    "verify_purchase": "yes",
    "item_type": "18cm / 2mm",
    "photo_url_1": null,
    "photo_url_2": null,
    "photo_url_3": null,
    "photo_url_4": null,
    "photo_url_5": null,
    "video_url": null,
    "block_no": 207
  },
  {
    "product_handle": "stardust-chain-necklace-gold",
    "rating": 5,
    "author": "O",
    "content": "光の当たり方でさりげなく輝くので、首元が明るい印象になります！普段のコーデに取り入れやすいです！",
    "commented_at": "2025-12-14",
    "reply": null,
    "reply_at": null,
    "verify_purchase": "yes",
    "item_type": null,
    "photo_url_1": null,
    "photo_url_2": null,
    "photo_url_3": null,
    "photo_url_4": null,
    "photo_url_5": null,
    "video_url": null,
    "block_no": 208
  },
  {
    "product_handle": "tiny-round-thin-ring-gold",
    "rating": 5,
    "author": "D",
    "content": "細めのリングですが存在感があり、指先がきれいに見えます！重ね付けにも使いやすく重宝しています！",
    "commented_at": "2025-12-08",
    "reply": null,
    "reply_at": null,
    "verify_purchase": "yes",
    "item_type": "12号",
    "photo_url_1": null,
    "photo_url_2": null,
    "photo_url_3": null,
    "photo_url_4": null,
    "photo_url_5": null,
    "video_url": null,
    "block_no": 209
  },
  {
    "product_handle": "flat-link-chain-necklace-silver",
    "rating": 5,
    "author": "S",
    "content": "カジュアルな服装でも首元が締まって見えるので重宝しています！使い勝手が良く、出番が多くなりました！",
    "commented_at": "2025-12-02",
    "reply": null,
    "reply_at": null,
    "verify_purchase": "yes",
    "item_type": "45cm",
    "photo_url_1": null,
    "photo_url_2": null,
    "photo_url_3": null,
    "photo_url_4": null,
    "photo_url_5": null,
    "video_url": null,
    "block_no": 210
  }

];
